{
  "version": 1,
  "asset_id": "443b4c28-0ccd-4049-a2db-e4ca6447531a",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/443b4c28-0ccd-4049-a2db-e4ca6447531a/werk-1.jpg",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/443b4c28-0ccd-4049-a2db-e4ca6447531a/werk-1.jpg",
  "original_filename": "werk-1.jpg",
  "size": 95043,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T13:29:56Z"
}
